import MerakiSDK from "@urbanpiper-engineering/meraki-sdk";
import configSelector from "../external/configSelector";
import React, { Dispatch, SetStateAction } from "react";

const useFetchGoogleMapKey = (googleApiKey: string) => {
  const fetchMapKey = async (
    setKey: Dispatch<SetStateAction<string>>,
    keyExists: Dispatch<SetStateAction<boolean>>,
  ) => {
    if (!googleApiKey) {
      try {
        const res = await MerakiSDK.getGMapKey();

        if (res?.getGmapKey.status) {
          const { key } = res.getGmapKey;
          configSelector.setDefaultMapsKey(key);
          keyExists(true);
          setKey(key);
        }
      } catch (error) {
        console.error(
          "[useFetchGoogleMapKey] Failed to fetch Google Map key:",
          error,
        );
      }
    } else if (googleApiKey) {
      keyExists(true);
    }
  };

  return fetchMapKey;
};

export default useFetchGoogleMapKey;
